import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import React from 'react';

import AuthLayout from '../../../Components/AuthLayout/AuthLayout';
import './LeadVettingStyle.less';
import { trackEvent } from '../utils';

import styles from './LeadVettingFormStyles.module.less';
import LeadVettingFormNew from './LeadVettingFormNew';

class LeadVettingPage extends React.Component {
  componentDidMount() {
    trackEvent('open', '');
  }

  render() {
    return (
      <AuthLayout wide>
        <div className={styles.leadVettingPageContainer}>
          <Helmet>
            <title>{gettext('Create account')}</title>
          </Helmet>
          <LeadVettingFormNew
            onSubmit={this.props.submitVettingForm}
            isLoading={this.props.isLoading}
            product={this.props.product}
            error={this.props.error}
            submitVettingStep1={this.props.submitVettingStep1}
            submitVettingStep2={this.props.submitVettingStep2}
            submitVettingStep3={this.props.submitVettingStep3}
            vettingStage={this.props.vettingStage}
            agreeToTerms={this.props.agreeToTerms}
            fields={this.props.fields}
            updateFields={this.props.updateFields}
          />
        </div>
      </AuthLayout>
    );
  }
}

LeadVettingPage.propTypes = {
  submitVettingForm: PropTypes.func,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  submitVettingStep1: PropTypes.func,
  submitVettingStep2: PropTypes.func,
  submitVettingStep3: PropTypes.func,
  product: PropTypes.string,
  vettingStage: PropTypes.string,
  agreeToTerms: PropTypes.func,
  fields: PropTypes.object,
  updateFields: PropTypes.func,
};

export default LeadVettingPage;
